import React, { useState, useEffect } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import history from './history';
import configureStore from './configureStore';
import { StoreContext } from './StoreContext';

export default function AppPersistWrapper({ initialStoreCongig, middlewares }) {
  const [storeConfig, setStoreConfig] = useState(initialStoreCongig);
  const changeStoreConfig = React.useCallback(
    (config) => {
      setStoreConfig(configureStore(config, middlewares));
    },
    [storeConfig.store],
  );
  return (
    <StoreContext.Provider value={{ changeStoreConfig }}>
      <Provider store={storeConfig.store}>
        <PersistGate loading={<div>loading</div>} persistor={storeConfig.persistor}>
          <App history={history} />
        </PersistGate>
      </Provider>
    </StoreContext.Provider>
  );
}
